angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/toolbars/search/search-results-suggestions.tpl.html',
    '<div id="map-search-results-suggestions" class="row" ng-show="search.results.suggestions.recordsInfo.selectedRecords">\n' +
    '  <div class="small-15 columns">\n' +
    '    <div class="map-search-result-container">\n' +
    '      <div class="row">\n' +
    '        <div class="small-15 columns">\n' +
    '          <span class="map-search-results-title right">\n' +
    '            Suggested People\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row map-search-result-user-row" ng-repeat="user in search.results.suggestions.records">\n' +
    '        <div class="small-3 medium-4 large-3 columns">\n' +
    '          <user-widget image-class="circle30" width="30" height="30" user="user"></user-widget>\n' +
    '        </div>\n' +
    '        <div class="small-10 medium-9 large-10 columns">\n' +
    '          <user-widget-name user="user"></user-widget-name>\n' +
    '        </div>\n' +
    '        <div class="small-2 medium-2 large-2 columns">\n' +
    '          <span class="map-search-result-action right">\n' +
    '            <network-add-icon user="user"></network-add-icon>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row map-search-result-user-row" ng-show="search.hasMore(\'suggestions\')">\n' +
    '        <div class="small-11 small-offset-2 columns end">\n' +
    '          <a class="load-more-link" ng-click="search.loadMore(\'suggestions\')">View more results ...</a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
